import "../../../../../node_modules/@vanilla-extract/webpack-plugin/vanilla.virtual.css?%7B%22fileName%22%3A%22src%2Fcomponents%2FvideoProductPage%2Fcomponents%2FVideoSection%2FVideoSection.css.ts.vanilla.css%22%2C%22source%22%3A%22%23H4sIAAAAAAAAA81Z6W6kOBD%2Bn6ewNFppIg0R5uoOI41298e%2BxsqAu9sJDQTc5yrvvsIY2kdhOtGMNKO5AuVyuY6vvjJP%2F%2BJdddmFGx%2F994BQwbqmJJcUbUp6%2Fv6AECnZtvIYp%2FsuRTmtOG2%2FP7w%2FPI3LAmiZ8j4U7%2Ffk7J1YwXcpWiXPjS4SwTvvKNvueIqCdSN%2BbkhRsGqboqg5I9z%2FNf6nf5uR%2FHXb1oeq8PK6rNsUHUn71fMOCeHlLuoehVDdFrT1WlKwQ5eisLnriLGwb1NX3NuQPSsvuu5gJ3SL9ydps%2Fae3d53%2FFJS4%2FWL8ppdaTodqWQV9SYv%2BMNDTs%2Fc4y2puk3d7lN0aBra5qSjmsmJ7tKqrqhwYd0xzuoqRS0tCWdH8XRP2i2rUuQjjOUu466x7xvBWsHB6v%2F1CtbSfNCf1%2BVhX%2FVvXg4dZ5uLl9cVpxW%2FeXjZ8eub40fHrny%2FXwmF%2BPxoO016cjihx%2BsmRTKbSso5bb2uIblIKv8pVBzc7UhRn1LkN2fxp8%2B0dpuRr%2F43JH8%2FJY%2BascSdJdSdJBtnjmzNFIl8IEXiYDytWWzOtNHdE5oBz2QBC5GSbniKcKC5tR22H5%2BqmZwMj6BwHXT35fY2kWFJYadDMqSDtsyEF6pqFmcMjCwPA2PJRizJD23Xm93UzErN7aLETkjAFadvjJCMlmUHg8t4qW5ehq1HvFTq2lClrHm1%2Ff8MRTlRgmxEQaSXPK3%2FFHSIko4iUpYK9GY15%2FU%2BRbg5o64uWYFOO8Z1Uzbprj7SFhm2zWrISpK%2FahpKdcGI9oGZ2dV9%2BbSC3BAbuuoZXYpIsyzypgZhPGgY2iBmnaW9KZelt4aayNpIA1b1703tvqH6ByrYEf1AzTcEPD2UVoGNdW%2BcZHisqO7ESoFNBc3rlgzJc6gK2g6GaXbInWRiy%2FBYrugQ%2BZjaD4nzzzl6LN0j61jGSsYvKdqxoqCVpv2oF%2FwQHi8r6z7BYRzlOo6eIA2axHnxuPLt9MS7oZh4ZpWIidSXuwrWUBIDfsSJ3VPW5mYSLpYA%2Ber27bK191lmFKoJFNc7rcUYwoJ4ZajDwe9ATrUl5eMi4ZjjAzYtwzCQmD0eR3CnzOqzxuX6qAYAl%2FPjx2%2BTAET2%2FFgZINTsUM8QZ9CUYeYrjqHIYpn%2Bs3RZ1ZCoGkb65QOdWdJlJX5hAsQvMgsYr0yYCyDGOcIcFM%2FjLQ1UmBHr%2Ba6tD9udvuV6IZP3diYn6vGA7K3N7NXeNvbAoL1%2Fe9TGznVzlux4ImzY9%2F8wKx5j05fPQ7EDPtrr2I3Jrx6uENqSRpI4deMM3vhe9RnpKEQkrN6McyBzYxtJXROwlgHR%2FDx4NJw7jA8l62SuePzS0BtUWIcXnsIhDECheTDqoPsyW8yxw%2FbOBuKtFn5sLQpyt7tMwol3v2n7mO4k7h1ep8g4IMkYOTGDu7AaRpJ1dXngAymS3LjvUj1h8QEkmOiB%2FPnqsaqg5xQF%2BtYvywRgmHospJlm%2B%2FHR%2FN0bBucgbE6ZeC%2FE6uyF5tzbsL7Oe44CHG9RVfUTEUy%2Fc7Awq%2F7chSVu5hg81FrAdqfDl1WfjULx7pwq8NuvNsoeECEiMF6YQRg7edo70eyVcS%2Brhez4o1CUl2TfiGxHqpxXt0xE90hbznIirgR6J23KnpoBkxDuHIAKpKq6lFsDaWRB7WH5Xhof3eCIOxscV25Ggg8uRoKPbkaCTwo2TogXWL3otADq7QKod25Q505WdVhgVUfoDBOv6i%2BDBPunKWpa6tmVcraCa11Z4utHUQjo9cN3BlN14C%2F49vRxlnpx%2BvPq9mfom%2F1StRbf1QCCwFFrs99lhp6gqgnvc3tbn5YIqm1ihEwSKTv8F%2F%2Bf%2BK%2Fg71npIygMla2qIJ7fbp1EDukjKLy0XeLOqhC7KzYMnBUbhq4MC6OFDIv1Oaifn2XPgZgqSL3C12Eynj7SpehLKH71fvhzTwtG0FeV3MT9PPso3GJ8S4Q%2FcLzP6IkiW8%2Bz1HO7IW%2FOaBXLbz3%2BqFBZ8WKtEPKujYO1vTG2DzAyK227QMq5ZABnjHIGdfK%2Fz9uuKIzgTZ0UzUoB31KbTHaOXxmlgxWkmC7h7tDnDh54MnKHq4Z5NRhNU29MAkAllSqtGydNiplSIyQuOHX0VZD0x5rNxs%2BqxStQbSXVQuTP5JdQkdSO9ZogjswDKAlww5kpT%2FTPMbHxWFq0VI84sOvxTdohWLroR6rDNJtb9XA6g9bXd5y03FrO55drchenRcvrr59ZDzpsHUaWvwKr9mZhSUGbIHSgzXQFCWWUhR2jw6cPqDG0zIYIYcOcKcSOTTjtpN%2BTQrtlmpH6t1MzSZ%2BB9exOjwE9CJR7m5eDGgOY5VD%2FAAfFj%2BT%2BT1WKsa51mAQgf0xoo%2B1vuURG6PbcAiJda2JnzTiK64IroPRBwbWLHYA1Gvk2piVGYQX%2BnTl%2Fa35aUMD2x4AzRU44CUOADk1WzA5mCx1tZoZ4f3j%2FH0trpwzYJgAA%22%7D"
export var aboutPage = '_1hnyh3f4';
export var aboutPageContainer = '_1hnyh3f2';
export var aboutPageTitle = '_1hnyh3f5';
export var audioFlexContainer = '_1hnyh3f23';
export var audioImageBorderRadius = '_1hnyh3f21';
export var audioImageContainer = '_1hnyh3f22';
export var audioPlayerContainer = '_1hnyh3f1z';
export var audioPlayerTitle = '_1hnyh3f20';
export var authorImageContainer = '_1hnyh3f1s';
export var authorImg = '_1hnyh3f1m';
export var authorImgBlock = '_1hnyh3f1l';
export var authorInfo = '_1hnyh3f1k';
export var authorName = '_1hnyh3fk';
export var authorShortDes = '_1hnyh3f1r';
export var authorTitle = '_1hnyh3f1o';
export var authorTitleShort = '_1hnyh3f1n';
export var betweenTopicDivider = '_1hnyh3f10';
export var black = '_1hnyh3f19';
export var counter = '_1hnyh3fv';
export var creatorType = '_1hnyh3f26';
export var ctaButton = '_1hnyh3f18';
export var description = '_1hnyh3fr';
export var descriptionBlock = '_1hnyh3fq';
export var descriptionHidden = '_1hnyh3ft';
export var flexContainer = '_1hnyh3f0';
export var holidayTheme = '_1hnyh3f24';
export var imageContainer = '_1hnyh3fh';
export var includedImageContainer = '_1hnyh3f1e';
export var includedItem = '_1hnyh3f1d';
export var includedItemImage = '_1hnyh3f1f';
export var includedItemText = '_1hnyh3f1g';
export var includedTitle = '_1hnyh3f1h';
export var moreThan4Lines = '_1hnyh3fu';
export var moreThan4LinesLessMode = '_1hnyh3fw';
export var offerBlock = '_1hnyh3f1a';
export var offerInfo = '_1hnyh3f1b';
export var offerInfoText = '_1hnyh3f1c';
export var pointer = '_1hnyh3f1j';
export var previewImageContainer = '_1hnyh3f7';
export var previewImageText = '_1hnyh3f8';
export var previewSection = '_1hnyh3f1x';
export var productBeatContainer = '_1hnyh3f1t';
export var productBuyInfo = '_1hnyh3f14';
export var productBuyNewPrice = '_1hnyh3f16';
export var productBuyOldPrice = '_1hnyh3f17';
export var productBuyPrice = '_1hnyh3f15 _1hnyh3f0';
export var productBuyVideo = '_1hnyh3f6';
export var productContainer = '_1hnyh3f3';
export var productInfo = '_1hnyh3f1';
export var rating = '_1hnyh3fn';
export var reviewsFullNumbers = '_1hnyh3fd';
export var reviewsNumbers = '_1hnyh3fc';
export var sectionBody = '_1hnyh3f1w';
export var sectionMargin = '_1hnyh3f1x';
export var sectionTitle = '_1hnyh3f1v';
export var sectionWrap = '_1hnyh3f1u';
export var separatorPoint = '_1hnyh3fb';
export var showMore = '_1hnyh3fx';
export var springTheme = '_1hnyh3f25';
export var title = '_1hnyh3fa';
export var titleBlock = '_1hnyh3f9';
export var titleText = '_1hnyh3f1p';
export var titleTextEditable = '_1hnyh3f1q';
export var topics = '_1hnyh3f11';
export var topicsTitle = '_1hnyh3f12';
export var underlineLinks = '_1hnyh3fs';
export var videoAuthor = '_1hnyh3ff _1hnyh3f0';
export var videoAuthorIcon = '_1hnyh3fl';
export var videoAuthorLink = '_1hnyh3fg _1hnyh3f0';
export var videoAuthorResponsive = '_1hnyh3fj';
export var videoDate = '_1hnyh3fp';
export var videoDetails = '_1hnyh3fe _1hnyh3f0';
export var videoDuration = '_1hnyh3fo';
export var videoPlayerOverlay = '_1hnyh3f1i';
export var videoReviews = '_1hnyh3f0';
export var videoReviewsResponsive = '_1hnyh3fi';
export var videoSectionShowLess = '_1hnyh3fz';
export var videoSectionShowMore = '_1hnyh3fy';
export var videos = '_1hnyh3f13';